
import { useEffect, useState } from "react";
import { localCache } from "../lib/localcache";
import { UserMetadata } from "../lib/definitions";
import styles from './Avatar.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faInstagram, faInstagramSquare} from  '@fortawesome/free-brands-svg-icons'

type AvatarData = UserMetadata & {avatarUrl?: string, avatarColour?: string};

export default function Avatar(props:{userId: number, name:string, debug?:boolean, useInstagramIcon?:boolean})
{
  
    const [metadata, setMetadata] = useState<AvatarData|null>(null);

    function randomColour()
    {
        let r=Math.floor(Math.random() * 0xbb);
        let g=Math.floor(Math.random() * 0xbb);
        let b=Math.floor(Math.random() * 0xbb);
        let c="rgb(" + r + ","+ g + "," + b + ")";
        return c;
    }
    async function initialize()
    {

        if (props.debug)
        {
           // console.log(props);
        }
        if (props.userId==0)
        {
            let z : AvatarData = {avatarColour: randomColour()};
            setMetadata(z);
            return;
        }
        let m = await localCache.getObject<AvatarData>("avatar|" + props.userId, async () =>
        {
        let a = await fetch(`${process.env.NEXT_PUBLIC_ELTON_ROUTE}/users/${props.userId}`, {
            method: 'GET',  cache: "no-store" as RequestCache, credentials:"include" as RequestCredentials});

            if (!a.ok)
            {
                return null;
            }

    

            let x=await a.json() as AvatarData;

            if (!x)
            {
                return null;
            }

            if (x.avatarGuid)
            {
                try
                {
                    let b = await fetch(`https://user-images.rawumberstudios.com/avatar_${x.avatarGuid}_24.jpg`, {method: 'GET', mode:'cors'});
                    let b2 = await b.blob();
                    //console.log(b2.size);
                    let u =  URL.createObjectURL(b2);
                    //console.log("Setting avatar URL to " + u);
                    x.avatarUrl = u;
                }
                catch
                {
                    console.error("Couldn't load avatar for " + x.avatarGuid);
                    x.avatarColour = randomColour();
                }
            }
            else
            {
                x.avatarColour = randomColour();
            }

            return x;
            
        });

       // console.log(m);

        setMetadata(m);

    }
    useEffect(()=>
    {
            initialize();
    }, [props.userId]);

    if (metadata && metadata.avatarUrl)
    {
        return <div className={styles.avatar}><img src={metadata.avatarUrl} /></div>
    }
    else if (props.userId==0 && props.useInstagramIcon)
    {
        return <div className={styles.avatar}><FontAwesomeIcon color="blue" size="xl" icon={faInstagram}/></div>
    }
    else
    {
        var c = (metadata?.avatarColour)??'#968d80';
        return <div className={styles.avatar} style={{backgroundColor:c}}>{props.name.toUpperCase().charAt(0)}</div>
    }

}